export type PeopleManagerState = {
  readonly selectedPersonId: number | undefined | null
  readonly personFormOpen: boolean
  readonly currentPage: number
  readonly limit: number
  readonly search: string
}

export const PEOPLE_MANAGER_STORE_ID = 'PeopleManager'
